export default "__VITE_ASSET__DGmz7h7E__"